<div class="header">
    <h3>{{ "Reporting.find.allyReporting" | translate }}</h3>
</div>
@if (isLoader()) {
<app-loader></app-loader>
}
<div class="cards-container">
    @for (report of reports; track report) {
    <app-report-card [report]="report" (outputData)="receiveData($event)"></app-report-card>
    }
</div>